import {
  Bdm1Outcome,
  NachversandKind,
  RetrievalMode,
  RetrievalStatus,
} from '@prisma/client';

// Why the BDM1 sample cannot be switched to a voucher right now, so a caller can explain a
// disabled button or reject the request. Null means the switch is allowed.
export type Bdm1SwitchBlockReason = 'notEligible' | 'alreadyPickedUp';

export type Bdm1SwitchCandidate = {
  nachversandKind: NachversandKind;
  retrievalMode: RetrievalMode;
  status: RetrievalStatus;
};

// The one precondition for switching a BDM1 sample to a voucher: a SAMPLE_LOCAL outcome still
// sitting in a BDM1 PICKUP retrieval. Shared by the panel's button state and the backend's
// authorization check so the two cannot drift apart.
export function bdm1SwitchBlockReason(
  retrieval: Bdm1SwitchCandidate | null | undefined,
  bdm1Outcome: Bdm1Outcome | null | undefined,
): Bdm1SwitchBlockReason | null {
  if (
    !retrieval ||
    retrieval.nachversandKind !== NachversandKind.BDM1 ||
    retrieval.retrievalMode !== RetrievalMode.PICKUP ||
    bdm1Outcome !== Bdm1Outcome.SAMPLE_LOCAL
  ) {
    return 'notEligible';
  }
  if (retrieval.status !== RetrievalStatus.READY_FOR_PICKUP) {
    return 'alreadyPickedUp';
  }
  return null;
}
